export default __webpack_public_path__ + "static/TTCommons-Medium-e1e7a9ea102531b6154b75523cd0e421.ttf";